import { roleApi } from './../../../api/user/roleApi';
import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eRoleActionTypeIds, IRoleActionTypes } from "../../action-types/user/IRoleActionTypes";
import { actions } from "../../actions";
import { IRole } from '../../../model/respone/user/IRole';
const mainAction = actions.role;
export function* roleSaga(): any {
    yield takeLatest(eRoleActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eRoleActionTypeIds.SAVE_START, saveWorker)
    yield takeLatest(eRoleActionTypeIds.DELETE_START, deleteWorker)
}
function* loadWorker(): any {
    const res: IBaseRespone = yield call(roleApi.getAll)
    if (res.is_success) {
        yield put(actions.role.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.role.LOAD_ERRR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IRoleActionTypes): any {
    const payload = action.payload as IRole;
    let res: IBaseRespone;
    if (payload.id > 0) {
        res = yield call(roleApi.update, payload);
    } else {
        res = yield call(roleApi.insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: IRoleActionTypes): any {
    const res: IBaseRespone = yield call(roleApi.delete, action.payload as number);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
    }
}